module.exports = __webpack_public_path__ + "img/map_newyork_bg_2.1575726f.jpg";